import {
  AccountsApi,
  Configuration,
  type CriiptoTokenLoginResponse,
  type HelseIDTokenLoginRequest,
} from '@trinnvis/dabih-api-client';

export async function helseIDLogin(requestParameters: HelseIDTokenLoginRequest): Promise<CriiptoTokenLoginResponse> {
  console.log('helseIDLogin - Request parameters:', JSON.stringify(requestParameters, null, 2));

  const config = new Configuration({ fetchApi: fetch });
  const api = new AccountsApi(config);

  try {
    console.log('helseIDLogin - Calling API endpoint...');
    const response = await api.helseIDTokenLogin(requestParameters);
    console.log('helseIDLogin - API response received:', JSON.stringify(response, null, 2));
    return response;
  } catch (error: any) {
    console.error('helseIDLogin - API call failed:', error);
    if (error?.response) {
      let errorData;
      try {
        errorData = await error.response.text();
      } catch {
        errorData = 'Could not read error response';
      }
      console.error('helseIDLogin - Error response details:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: errorData,
        headers: error.response.headers,
        url: error.response.url,
      });
    }
    throw error;
  }
}
